export default __webpack_public_path__ + "static/media/bookOne.1df506a0.png";